import { Card, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TraxxButton } from 'app/components';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  form: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: 500,
    justifyContent: 'space-between',
    padding: 40,
    width: 410,
  },
  image: {
    height: 200,
    width: 200,
  },
  link: { alignSelf: 'flex-start' },
}));

function SuccessView(props) {
  const classes = useStyles();

  const { email } = props;
  return (
    <Card className={classes.card}>
      <form className={classes.form} autoComplete="false">
        <Grid container justify="flex-start">
          <TraxxButton component={RouterLink} startIcon={<img src="/images/arrow_back.svg" alt="back to log in" />} to="/access/login" variant="text">
            Back to log in
          </TraxxButton>
        </Grid>

        <img className={classes.image} src="/images/sent_mail.svg" alt="sent mail" />

        <Typography variant="h5">Registration submitted</Typography>

        <Typography align="center" variant="body2">
          We have sent you instructions to activate your account at <strong>{email}</strong>&#46;
        </Typography>
      </form>
    </Card>
  );
}

export default SuccessView;
